import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import {HelpersService} from "../../../services/tools/helpers.service";

declare var moment;

@Component({
  selector: 'app-modal-intereses-moratorios',
  templateUrl: './modal-intereses-moratorios.component.html',
  styleUrls: ['./modal-intereses-moratorios.component.scss']
})
export class ModalInteresesMoratoriosComponent implements OnInit {

  public modal: any = null;

  public cuentasRelacionadas: any[] = [];
  public errors: any = {};
  
  //Modelos
  public cuentas: any = [];
  public cuentaPorCobrar: any = [];

  //Helpers
  public loading: boolean = null;

  @ViewChild('content') private content: TemplateRef<any>;
  @Output() public onInteresesEliminados: EventEmitter<any> = new EventEmitter;

  constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
    private modalService: NgbModal,
    public helperService: HelpersService) { }

  ngOnInit() {
  }

  public openModal(cuentaPorCobrar: any){
    this.modal = this.modalService.open(this.content, { });
    this.cuentaPorCobrar = cuentaPorCobrar;
    this.obtenerCuentasInteresesMoratorios();
  }

  public closeModal(reloadParent) {
    this.modal.close();
  }

  private obtenerCuentasInteresesMoratorios(){
    this.loading = true;
    this.cuentas_por_cobrar_service.listarCuentasInteresesMoratorios(this.cuentaPorCobrar.id_cuenta_por_cobrar)
    .subscribe(
      (response)=>{
        this.cuentas = response.json().content;
        //Si la cuenta no tiene intereses moratorios, actualizamos el modelo para que en el reporte, no se pueda entrar a este modal
        if(this.cuentas.length == 0){
          this.cuentaPorCobrar.no_intereses_moratorios = 0;
        }

        this.loading = false;
      },
      (error)=>{
        this.loading = false;
        alert("ERROR:: "+JSON.stringify(error));
      }
    );
  }

  public eliminarCuenta(cuenta) {

    //TODO: Modal de confirmación
    if(!confirm("¿Estas seguro que deseas eliminar el interés moratorios?")) return;

    cuenta.loading = true;
    this.cuentas_por_cobrar_service.eliminarCuentaInteresesMoratorios(cuenta.id_interes_por_cobrar)
    .subscribe(
      (response)=>{
        this.obtenerCuentasInteresesMoratorios();
        cuenta.loading = false;
        this.helperService.notification('Interés moratorio eliminado', 'Se ha eliminado exitosamente el interés moratorio ', 'success');
        
        //Por ahora no esta enlazado a algún evento en el reporte, pero se podría enlazar una función en el futuro
        if(this.onInteresesEliminados){
          this.onInteresesEliminados.emit();
        }
      },
      (error)=>{
        cuenta.loading = false;
        alert("ERROR:: " + JSON.stringify(error));
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-cxc/modal-intereses-moratorios/modal-intereses-moratorios.component.ts